import Icon from '../Icon';
import { formatDate } from '../../utilities';

export const renderValue = (
  value: any,
  format?: DynamicColumnCompositeSubFieldType['format']
) => {
  switch (format) {
    case 'date':
      return formatDate(value);

    case 'boolean': {
      if (value === undefined || value === null) return '';

      return (
        <Icon
          icon={value ? 'yes' : 'no'}
          iconStyle={value ? 'default' : 'danger'}
        />
      );
    }

    default:
      return value !== null && value !== undefined ? String(value) : '';
  }
};
